import {
  ADD_CART_ITEM_REQUEST,
  ADD_COUPON_REQUEST,
  ADD_GIFT_CARD_REQUEST,
  ADD_LOYALTY_TENDER_REQUEST,
  CHARGE_CART_REQUEST,
  CHARGE_FULLSTEAM_WALLET_REQUEST,
  CREATE_CART_PAYMENT_INTENT_REQUEST,
  GET_AUTH_FULLSTEAM_WALLET,
  GET_CART_FOR_SHARING_REQUEST,
  GET_CART_FROM_PAY_GATE_REQUEST,
  GET_CART_REQUEST,
  REMOVE_CART_ITEM_REQUEST,
  REMOVE_TENDER_REQUEST,
  REPLACE_TENDER_ON_CART_REQUEST,
  SEND_CART_TO_PAY_GATE_REQUEST,
  SIDE_CART_NOT_VISIBLE,
  SIDE_CART_VISIBLE,
  UPDATE_CART_ITEM_REQUEST,
  UPDATE_CART_REQUEST,
  VERIFY_PAYSTACK_REQUEST
} from './constants';

export const getCart = () => ({ type: GET_CART_REQUEST });

export const getForSharing = (id, onSuccess) => ({
  id,
  type: GET_CART_FOR_SHARING_REQUEST,
  onSuccess
});

export const addCartItem = (item, onSuccess, onError) => ({
  type: ADD_CART_ITEM_REQUEST,
  item,
  onSuccess,
  onError
});

export const removeCartItem = (
  itemId,
  useLoyaltyPoints,
  onSuccess,
  onError
) => ({
  type: REMOVE_CART_ITEM_REQUEST,
  itemId,
  useLoyaltyPoints,
  onSuccess,
  onError
});

export const updateCartItem = (
  itemId,
  quantity,
  useLoyaltyPoints,
  onSuccess,
  onError
) => ({
  type: UPDATE_CART_ITEM_REQUEST,
  quantity,
  itemId,
  useLoyaltyPoints,
  onSuccess,
  onError
});

export const showSideCart = () => ({
  type: SIDE_CART_VISIBLE
});

export const hideSideCart = () => ({
  type: SIDE_CART_NOT_VISIBLE
});

export const updateCart = (cart, onSuccess, onError) => ({
  type: UPDATE_CART_REQUEST,
  cart,
  onSuccess,
  onError
});

export const createPaymentIntent = (params) => ({
  type: CREATE_CART_PAYMENT_INTENT_REQUEST,
  params
});

export const authenticateFullSteamWallet = (onSuccess, onError) => ({
  type: GET_AUTH_FULLSTEAM_WALLET,
  onSuccess,
  onError
});

export const chargeFullSteamWallet = (
  hostedPaymentsAccountId,
  onSuccess,
  onError
) => ({
  type: CHARGE_FULLSTEAM_WALLET_REQUEST,
  hostedPaymentsAccountId,
  onSuccess,
  onError
});

export const replaceTender = (tender, onSuccess, onError) => ({
  type: REPLACE_TENDER_ON_CART_REQUEST,
  tender,
  onSuccess,
  onError
});

export const chargeCart = (token, onSuccess, onError) => ({
  type: CHARGE_CART_REQUEST,
  token,
  onSuccess,
  onError
});

export const verifyPayStack = (tenderId, onSuccess, onError) => ({
  type: VERIFY_PAYSTACK_REQUEST,
  tenderId,
  onSuccess,
  onError
});

export const addCoupon = (couponCode, onSuccess, onError) => ({
  type: ADD_COUPON_REQUEST,
  couponCode,
  onSuccess,
  onError
});

export const addGiftCard = (giftCardCode, onSuccess, onError) => ({
  type: ADD_GIFT_CARD_REQUEST,
  giftCardCode,
  onSuccess,
  onError
});

export const addLoyaltyTender = (tender, onSuccess, onError) => ({
  type: ADD_LOYALTY_TENDER_REQUEST,
  tender,
  onSuccess,
  onError
});

export const removeTender = (tenderId, onSuccess, onError) => ({
  type: REMOVE_TENDER_REQUEST,
  tenderId,
  onSuccess,
  onError
});

export const sendToPayGate = (redirectFunction) => ({
  type: SEND_CART_TO_PAY_GATE_REQUEST,
  redirectFunction
});

export const getCartForPayGate = (onSuccess, onError) => ({
  type: GET_CART_FROM_PAY_GATE_REQUEST,
  onSuccess,
  onError
});
